import * as api from "@/api/team";
import formatDateFilter from "@/utils/formatDateFilter";

const initState = () => ({
  clid: "",
  team: [],
  page: 1,
  pageSize: 10,
  filter: [],
  sort: [],
  total: null,
});

export default {
  namespaced: true,
  state: initState,
  getters: {
    hasTeam: (state) => state.total > 0,
    dateFilter: (state) => {
      const filter = state.filter.find((f) => f.field === "registration_date");
      return formatDateFilter(filter);
    },
  },
  mutations: {
    set: (state, payload) => (state[payload.type] = payload.value),
    setPage: (state, value) => (state.page = value),
    setPageSize: (state, value) => (state.pageSize = value),
    setTeam: (state, value) => (state.team = value),
    setClid: (state, value) => (state.clid = value),
    setDateFilter: (state, payload) => {
      state.filter = state.filter.filter(({ field }) => field !== "registration_date");

      const daddFilter = {
        field: "registration_date",
        logic: "and",
        filters: [],
      };

      if (payload.start) {
        daddFilter.filters.push({
          operator: "gte",
          value: payload.start,
        });
      }
      if (payload.end) {
        daddFilter.filters.push({
          operator: "lte",
          value: payload.end,
        });
      }

      if (daddFilter.filters.length > 0) {
        state.filter.push(daddFilter);
      }
    },
    setSort: (state, { sortBy: _sortBy, sortDesc: _sortDesc }) => {
      const sortBy = _sortBy[0];
      const sortDesc = _sortDesc[0];
      if (!sortBy) state.sort = [];
      else state.sort = [{
        field: sortBy,
        dir: sortDesc ? "desc" : "asc",
      }];
    },
    setTotal: (state, payload) => {
      state.total = payload;
    },
    reset: state => {
      const initialState = initState();
      Object.keys(initialState).forEach(key => (state[key] = initialState[key]));
    },
  },
  actions: {
    async getTeam({ commit, state: { filter, page, pageSize, sort } }) {
      const res = await api.getTeam({ filter, page, pageSize, sort });
      if (res) {
        if (res.list) {
          commit("setTeam", res.list);
        }
        if (res.user_id) {
          commit("setClid", res.user_id);
        }
        commit("setTotal", res.total);
      }
    },
    async getLink({ commit }) {
      const res = await api.getLink();
      if (res) {
        if (res.user_id) {
          commit("setClid", res.user_id);
        }
      }
    },
  },
};
